import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const SchedulingBreadcrumbBar: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center gap-1.5 text-xs text-slate-500 font-sans">
      <button
        type="button"
        className="hover:text-slate-900 transition font-medium cursor-pointer"
        onClick={() => navigate("/admin/sessions")}
      >
        Sessions
      </button>
      <ChevronRight className="w-3.5 h-3.5 text-slate-400" />
      <span className="text-slate-900 font-semibold">New Session Scheduling</span>
    </div>
  );
};

